import {uniq, filter, createSelector} from 'helpers';

export const passionSummary = createSelector(
  state => state.identity,
  state => uniq(filter([
    state['passion-inquiry-1'][1],
    state['passion-inquiry-1'][2],
    state['passion-inquiry-1'][3],
    state['passion-inquiry-1'][4],
    state['passion-inquiry-1'][5],
    state['passion-inquiry-1'][6],
    state['passion-inquiry-1'][7],
    state['passion-inquiry-1'][8],
    state['passion-inquiry-1'][9],
    state['passion-inquiry-1'][10],
    state['passion-inquiry-1'][11],
    state['passion-inquiry-1'][12],
    state['passion-inquiry-2'][1],
    state['passion-inquiry-2'][2],
    state['passion-inquiry-2'][3],
    state['passion-inquiry-2'][4],
    state['passion-inquiry-2'][5],
    state['passion-inquiry-2'][6],
  ]))
);

export const strengthSummary = createSelector(
  state => state.identity,
  state => uniq(filter([
    state['strengths-inquiry-1'][1],
    state['strengths-inquiry-1'][2],
    state['strengths-inquiry-1'][3],
    state['strengths-inquiry-1'][4],
    state['strengths-inquiry-1'][5],
    state['strengths-inquiry-1'][6],
    state['strengths-inquiry-1'][7],
    state['strengths-inquiry-1'][8],
    state['strengths-inquiry-1'][9],
    state['strengths-inquiry-1'][10],
    state['strengths-inquiry-2'][4],
    state['strengths-inquiry-2'][5],
    state['strengths-inquiry-2'][6],
    state['strengths-inquiry-2'][10],
    state['strengths-inquiry-2'][11],
    state['strengths-inquiry-2'][12],
  ]))
);
